import { getUnitLabel, getStock } from "../Cart/CartFunctions";
export class QuantitySelectorProduct extends React.Component {
    constructor(props) {
        super();
        this.state = {
            inputVal: props.value,
            inputTrack: null,
            minimumQuantity: null,
        };

    }
    componentDidMount() {
        var self = this;
        setTimeout(() => {
            let stockSpecialOrder;
            if (this.props.cart && this.props.item.stockAvailability) {
                stockSpecialOrder = getStock(this.props.cart, this.props.item.stockAvailability);
            }

            this.setState({
                open: true,
                minimumQuantity: stockSpecialOrder && stockSpecialOrder.minimumQuantity
            });

        },300)
       
    }
    quantityHandler(event) {
        var self = this;
        const minimumQuantityContainer = this.minimumQuantityContainer;
        this.setState({
            inputVal: event.target.value
        }, () => {

            if (minimumQuantityContainer) {

                if (this.state.minimumQuantity > this.state.inputVal) {
                    minimumQuantityContainer.classList.add('validate-error');
                } else {
                    minimumQuantityContainer.classList.remove('validate-error');
                }
                if (!this.state.inputVal) {
                    minimumQuantityContainer.classList.remove('validate-error');
                }
            } 
            self.props.onChange({
                target: {
                    value: this.state.inputVal
                }
            });
        });
        
    }

    quantityOnBlurHandler() {
    }

    quantitySelectorValidation(value) {
        const minimumQuantityContainer = this.minimumQuantityContainer;
        if (minimumQuantityContainer) {
            if (this.state.minimumQuantity > value) {
                minimumQuantityContainer.classList.add('validate-error');
            } else {
                minimumQuantityContainer.classList.remove('validate-error');
            }
        }
    }

    resetHandler() {
        var self = this;
        const minimumQuantityContainer = this.minimumQuantityContainer;

        if (minimumQuantityContainer) {
            minimumQuantityContainer.classList.remove('validate-error');
        }

        this.setState({
            inputVal: ''
        }, () => {

            self.props.onChange({
                target: {
                    value: ''
                }
            });
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.inputVal) {
            this.setState({ inputVal: nextProps.value });
        }
    }

    renderQuantitySelector(amount, type) {
        let returnedNum = 0;
        let palletUsage, layerUsage, packUsage = 1;

        if (this.props.palletQty !== 0 && this.props.palletQty !== null) {
            palletUsage = Math.floor(this.state.inputVal / this.props.palletQty);
        }
        if (this.props.layerQty !== 0 && this.props.layerQty !== null) {
            layerUsage = Math.floor((this.state.inputVal - (this.props.palletQty ? palletUsage * this.props.palletQty : 0)) / this.props.layerQty);
        }
        if (this.props.packQty !== 0 && this.props.packQty !== null) {
            packUsage = Math.floor((this.state.inputVal - (this.props.palletQty ? palletUsage * this.props.palletQty : 0) - (this.props.layerQty ? layerUsage * this.props.layerQty : 0)) / this.props.packQty);
        }

        var singleUsage = this.state.inputVal - (this.props.palletQty ? palletUsage * this.props.palletQty : 0) - (this.props.layerQty ? layerUsage * this.props.layerQty : 0) - (this.props.packQty ? packUsage * this.props.packQty : 0);

        let UnitType;
        switch (type) {
            case 'single':
                returnedNum = singleUsage;
                break;
            case 'pack':
                UnitType = '(Carton)';
                returnedNum = packUsage;
                break;
            case 'layer':
                UnitType = '(Layer)';
                returnedNum = layerUsage;
                break;
            case 'pallet':
                UnitType = '(Pallet)';
                returnedNum = palletUsage;
                break;
            default:
                console.log(`none`);
        }

        var self = this;
        return <div className='unit-selector-container'>
            <button className="unit-selector" onClick={() => {
                self.props.onChange({
                    target: {
                        value: +self.props.value + amount
                    }
                });
                this.quantitySelectorValidation(+self.props.value + amount);
            }}>{amount} x {getUnitLabel(amount, self.props.unit, self.props.unitPlural)} { UnitType }</button>
            <div className='unit-quantity-container' onClick={() => {
                self.props.onChange({
                    target: {
                        value: +self.props.value + amount
                    }
                });

                this.quantitySelectorValidation(+self.props.value + amount);
            }}>{returnedNum}
                <i className="icon icon-leaf"></i></div>
            
        </div>;
    }
    //{ this.renderQuantitySelector(1, 'single') }
    render() {
      
        return <div className="quantity-selector">
            <div className="quantity-selector-container">
                <div className="inner-title text-left">
                    {this.props.packQty < 1 && this.props.layerQty < 1 && this.props.palletQty < 1 ? <p></p> : <p className='font-weight-bold mb-0'>Choose quantities:</p>}
                </div>
                <div className='popover-options'>
                    {this.props.packQty > 1 && this.renderQuantitySelector(parseFloat(this.props.packQty), 'pack')}
                    {(this.props.layerQty > 1 && this.props.layerQty != this.props.packQty)  && this.renderQuantitySelector(parseFloat(this.props.layerQty), 'layer')}
                    {(this.props.palletQty > 1 && this.props.palletQty != this.props.layerQty && this.props.palletQty != this.props.packQty) && this.renderQuantitySelector(parseFloat(this.props.palletQty), 'pallet')}
                </div>
                <div className='popover-custom my-3 text-left'>
                    <div className='popover-input-label-container'>
                        {this.props.packQty < 1 && this.props.layerQty < 1 && this.props.palletQty < 1 ? <p>Type how many:</p> : <p>or type how many:</p>}
                        <div className='clear-container'>
                           <small onClick={this.resetHandler.bind(this)}>Clear</small>
                        </div>
                    </div>
                    {!this.state.minimumQuantity &&
                        <input ref={(input) => { this.inputRef = input; }} type='number' onBlur={this.quantityOnBlurHandler.bind(this)} value={this.state.inputVal === 0 ? '' : this.state.inputVal} onChange={this.quantityHandler.bind(this)} />
                    }
                    {this.state.minimumQuantity &&
                        <div ref={div => { this.minimumQuantityContainer = div }} className='minimum-quantity mt-2'>
                            <p className='font-weight-bold mb-0'> Minimum Purchase Quantity: {this.state.minimumQuantity}</p>
                        </div>
                    }
                </div>
                <div className='sustainable-options'>
                    {(this.props.packQty > 1 || this.props.layerQty > 1 || this.props.palletQty > 1) && <small className='mb-0 '><i className="icon icon-leaf"></i>Above are multi-pack quantity break sustainable options.</small>}
                    <a href='/sustainable-options'>Learn more.</a>
                </div>
            </div>
        </div>
    }
}